module.exports = __webpack_public_path__ + "img/3.3ad7e1b2.jpg";